
// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { Helmet } from "react-helmet";
// import { Link } from 'react-router-dom';
// import useToggleSidebar from "../../components/togglesidebar";
// import Icons from "../../components/icons";
// import SortIcon from "../../components/table/SortIcon";
// import Sidebar from '../sidebar';
// import Header from '../Header';
// import Footer from '../footer';
// import DeleteModal from "../../components/Modal/Modal";
// import api from "../../services/api";
// import API_URL from "../../config/config";
// import dayjs from 'dayjs';

// function BlogList() {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage, setItemsPerPage] = useState(10);
//     const [searchTerm, setSearchTerm] = useState("");
//     const [totalItems, setTotalItems] = useState(0);
//     const token = localStorage.getItem("adminToken");
//     const { isSidebarOpen, toggleSidebar } = useToggleSidebar();
//     const [sortField, setSortField] = useState("_id");
//     const [sortOrder, setSortOrder] = useState("desc");
//     const [deleteId, setDeleteId] = useState(null);
//     const [refreshTrigger, setRefreshTrigger] = useState(0);
//     const [deletingId, setDeletingId] = useState(null);

//     const drawCounter = useRef(0);

//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         setError(null);
//         try {
//             const response = await api.get(`/blogs`, {
//                 params: {
//                     page: currentPage,
//                     limit: itemsPerPage,
//                     search: searchTerm,
//                     sortField,
//                     sortOrder
//                 }
//             });

//             if (response.data.success) {
//                 const blogs = response.data.posts || response.data.data || [];
//                 setData(blogs);
//                 setTotalItems(response.data.total || blogs.length);
//             } else {
//                 setData([]);
//                 setTotalItems(0);
//             }
//         } catch (err) {
//             console.error("Error fetching blog list:", err.response?.data || err.message);
//             setError(err.response?.data?.message || "Unable to fetch blog data.");
//             setData([]);
//             setTotalItems(0);
//         } finally {
//             setLoading(false);
//         }
//     }, [currentPage, itemsPerPage, searchTerm, sortField, sortOrder]);

//     useEffect(() => {
//         fetchData();
//     }, [currentPage, itemsPerPage, searchTerm, sortField, sortOrder, refreshTrigger, fetchData]);

//     const totalPages = Math.ceil(totalItems / itemsPerPage);


//     const handleDelete = async () => {
//         if (!deleteId) {
//             console.warn("handleDelete called with no id");
//             return;
//         }
//         if (deletingId) return; // Prevent duplicate deletes
//         setDeletingId(deleteId);

//         try {
//             await api.delete(`/bloglist/${deleteId}`);
//             setDeleteId(null); // Close modal
//             setRefreshTrigger(prev => prev + 1); // Refresh data

//             // Adjust page if the last item on it was deleted
//             const remaining = Math.max(totalItems - 1, 0);
//             if (currentPage > 1 && remaining > 0 && remaining % itemsPerPage === 0) {
//                 setCurrentPage(prev => Math.max(1, prev - 1));
//             }
//         } catch (err) {
//             console.error("Delete failed:", err.response?.data || err.message);
//             alert(err.response?.data?.message || "Failed to move blog to trash.");
//         } finally {
//             setDeletingId(null);
//         }
//     }


//     const handleSort = (field) => {
//         if (sortField === field) {
//             setSortOrder(sortOrder === "asc" ? "desc" : "asc");
//         } else {
//             setSortField(field);
//             setSortOrder("asc");
//         }
//         setCurrentPage(1);
//     };

//     const renderPaginationButtons = () => {
//         const pages = [];
//         const totalNumbersToShow = 5;
//         const half = Math.floor(totalNumbersToShow / 2);

//         let startPage = Math.max(currentPage - half, 1);
//         let endPage = Math.min(currentPage + half, totalPages);

//         if (currentPage <= half) {
//             endPage = Math.min(totalNumbersToShow, totalPages);
//         }

//         if (currentPage > totalPages - half) {
//             startPage = Math.max(totalPages - totalNumbersToShow + 1, 1);
//         }

//         if (totalPages < totalNumbersToShow) {
//             startPage = 1;
//             endPage = totalPages;
//         }

//         if (startPage > 1) {
//             pages.push(
//                 <button key={1} className={`paginate_button ${currentPage === 1 ? "current active" : ""}`} onClick={() => setCurrentPage(1)}>
//                     1
//                 </button>
//             );
//             if (startPage > 2) {
//                 pages.push(<span key="start-ellipsis" className="ellipsis">...</span>);
//             }
//         }

//         for (let i = startPage; i <= endPage; i++) {
//             pages.push(
//                 <button
//                     key={i}
//                     className={`paginate_button ${currentPage === i ? "current active" : ""}`}
//                     onClick={() => setCurrentPage(i)}
//                 >
//                     {i}
//                 </button>
//             );
//         }

//         if (endPage < totalPages) {
//             if (endPage < totalPages - 1) {
//                 pages.push(<span key="end-ellipsis" className="ellipsis">...</span>);
//             }
//             pages.push(
//                 <button key={totalPages} className={`paginate_button ${currentPage === totalPages ? "current active" : ""}`} onClick={() => setCurrentPage(totalPages)}>
//                     {totalPages}
//                 </button>
//             );
//         }

//         return pages;
//     };

//     // Define the number of columns for the skeleton loader based on your <thead>
//     // No. | Title | Description | URL | Status | Image | Created At | Actions = 8 columns
//     const numTableColumns = 4;

//     return (
//         <>
//             <Helmet>
//                 <title>Admin | Blogs</title>
//             </Helmet>
//             <Sidebar isSidebarOpen={isSidebarOpen} />
//             <div className={`content-overlay ${isSidebarOpen && window.innerWidth <= 992 ? "blurred" : ""}`} onClick={() => isSidebarOpen && window.innerWidth <= 992 && toggleSidebar()}>
//                 <div className="content-wrapper" style={{ marginLeft: isSidebarOpen ? "250px" : "70px", transition: "margin-left .3s" }}>
//                     <Header toggleSidebar={toggleSidebar} />
//                     <section className='content'>
//                         <div className="breadcrumb-main-bx">
//                             <div className="breadcrumb-bx">
//                                 <Link className="breadcrumb-link" to="/admin/dashboard">Dashboard</Link>
//                                 <div className="breadcrumb-link breadcrumb-disabled">/</div>
//                                 <div className="breadcrumb-link breadcrumb-active">Blogs</div>
//                             </div>
//                         </div>
//                         <div className='container-fluid'>
//                             <div className='row'>
//                                 <div className='col-md-12'>
//                                     <div className='card'>
//                                         <div className="card-header d-flex justify-content-between align-items-center">
//                                             <div>News</div>
//                                             <div className="common-field common-field-date gap-3">
//                                                 <Link to="/admin/bloglist/add" className="cbi-small common-btn-item cbi-fill text-decoration-none"><span>Add Blog</span></Link>
//                                             </div>
//                                         </div>
//                                         <div className='card-body'>
//                                             <div id='challenge-requests-table_wrapper' className='dataTables_wrapper no-footer'>
//                                                 <div className='dataTables_length' id='challenge-requests-table_length'>
//                                                     <label>Show
//                                                         <select
//                                                             value={itemsPerPage}
//                                                             onChange={(e) => {
//                                                                 setItemsPerPage(Number(e.target.value));
//                                                                 setCurrentPage(1);
//                                                             }}
//                                                         >
//                                                             <option value="10">10</option>
//                                                             <option value="25">25</option>
//                                                             <option value="50">50</option>
//                                                             <option value="100">100</option>
//                                                         </select>
//                                                         entries
//                                                     </label>
//                                                 </div>
//                                                 <div id='challenge-requests-table_filter' className='dataTables_filter'>
//                                                     <label>Search:
//                                                         <input
//                                                             type="search"
//                                                             className=""
//                                                             placeholder="Search..."
//                                                             aria-controls="challenge-requests-table"
//                                                             value={searchTerm}
//                                                             onChange={(e) => {
//                                                                 setSearchTerm(e.target.value);
//                                                                 setCurrentPage(1);
//                                                             }}
//                                                         />
//                                                     </label>
//                                                 </div>
//                                                 <div className='table-responsive'>
//                                                     <table className="table table-bordered dataTable no-footer overflow-x-auto mt-2" id="challenge-requests-table">
//                                                         <thead>
//                                                             <tr role="row">
//                                                                 <th>No.</th>
//                                                                 <th
//                                                                     className={`sorting_${sortField === "title" ? sortOrder : ""}`}
//                                                                     onClick={() => handleSort("title")}
//                                                                 >
//                                                                     Title <SortIcon />
//                                                                 </th>
//                                                                 {/* <th>Description</th> */}
//                                                                 {/* <th>URL</th> */}
//                                                                 <th
//                                                                     className={`sorting_${sortField === "status" ? sortOrder : ""}`}
//                                                                     onClick={() => handleSort("status")}
//                                                                 >
//                                                                     Status <SortIcon />
//                                                                 </th>
//                                                                 {/* <th>Image</th>
//                                                                 <th
//                                                                     className={`sorting_${sortField === "createdAt" ? sortOrder : ""}`}
//                                                                     onClick={() => handleSort("createdAt")}
//                                                                 >
//                                                                     Created At <SortIcon />
//                                                                 </th> */}
//                                                                 <th>Actions</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {loading ? (
//                                                                 // Skeleton loading rows, matched to PromoCode's column-wise skeleton
//                                                                 Array.from({ length: itemsPerPage }).map((_, rowIndex) => (
//                                                                     <tr key={`skeleton-${rowIndex}`}>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                         <td><div className="skeletant-bx skeletant-design sh-47"></div></td>
//                                                                     </tr>
//                                                                 ))
//                                                             ) : error ? (
//                                                                 <tr>
//                                                                     <td colSpan={numTableColumns} style={{ textAlign: "center", padding: "10px", color: "red" }}>{error}</td>
//                                                                 </tr>
//                                                             ) : data.length > 0 ? (
//                                                                 data.map((row, index) => (
//                                                                     <tr key={row._id || row.id}>
//                                                                         <td>{itemsPerPage * (currentPage - 1) + index + 1}</td>
//                                                                         <td>{row.title}</td>
//                                                                         {/* <td>{row.description.substring(0, 50)}...</td> */}
//                                                                         {/* <td><a href={row.url} target="_blank" rel="noopener noreferrer">{row.url}</a></td> */}
//                                                                         <td>{row.status || 'active'}</td>
//                                                                         {/* <td>
//                                                                             {row.image_url ? (
//                                                                                 <img src={row.image_url} alt={row.title} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
//                                                                             ) : (
//                                                                                 <span>No Image</span>
//                                                                             )}
//                                                                         </td> */}
//                                                                         {/* <td>{dayjs(row.createdAt).format("DD-MM-YYYY HH:mm")}</td> */}
//                                                                         <td>
//                                                                             <Link to={`/admin/bloglist/edit/${row._id || row.id}`} className="common-action-btn toggle-status" title="Edit">
//                                                                                 <Icons.EditIcon />
//                                                                             </Link>
//                                                                             <Link to="#" className="common-action-btn" title="delete" onClick={() => setDeleteId(row._id || row.id)}>
//                                                                                 <Icons.DeleteIcon />
//                                                                             </Link>
//                                                                         </td>
//                                                                     </tr>
//                                                                 ))
//                                                             ) : (
//                                                                 <tr>
//                                                                     <td colSpan={numTableColumns} style={{ textAlign: "center", padding: "10px" }}>No data available in table</td>
//                                                                 </tr>
//                                                             )}
//                                                         </tbody>
//                                                     </table>
//                                                 </div>

//                                                 <div className="dataTables_info">
//                                                     Showing {totalItems === 0 ? 0 : (itemsPerPage * (currentPage - 1)) + 1} to{" "}
//                                                     {Math.min(itemsPerPage * currentPage, totalItems)} of {totalItems} entries
//                                                 </div>

//                                                 <div className="dataTables_paginate paging_simple_numbers">
//                                                     <Link to="#" className={`paginate_button previous ${currentPage === 1 ? "disabled" : ""}`} onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Previous</Link>
//                                                     <span>
//                                                         {renderPaginationButtons()}
//                                                     </span>
//                                                     <Link to="#" className={`paginate_button next ${currentPage === totalPages ? "disabled" : ""}`} onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>Next</Link>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </section>
//                     <Footer />
//                 </div>
//             </div>
//             {deleteId && (
//                 <DeleteModal
//                     isOpen={!!deleteId}
//                     onClose={() => setDeleteId(null)}
//                     onConfirm={handleDelete}
//                     title="Move to Trash"
//                     message="Are you sure you want to move this blog to the trash?"
//                 />
//             )}
//         </>
//     );
// }
// export default BlogList;
/**
 * ✅ FUNCTIONALITY FIXED
 * ❌ NO CSS OR DESIGN CHANGES
 * ❌ NO LAYOUT CHANGES
 */

import React, { useState, useEffect, useCallback, useRef } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import useToggleSidebar from "../../components/togglesidebar";
import Icons from "../../components/icons";
import SortIcon from "../../components/table/SortIcon";
import Sidebar from "../sidebar";
import Header from "../Header";
import Footer from "../footer";
import DeleteModal from "../../components/Modal/Modal";
import api from "../../services/api";

let blogsListCache = null;

function BlogList() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(() => blogsListCache?.currentPage || 1);
    const [itemsPerPage] = useState(() => blogsListCache?.itemsPerPage || 10);
    const [searchTerm] = useState(() => blogsListCache?.searchTerm || "");
    const [totalItems, setTotalItems] = useState(0);

    const { isSidebarOpen, toggleSidebar } = useToggleSidebar();
    const [sortField, setSortField] = useState("_id");
    const [sortOrder, setSortOrder] = useState(() => blogsListCache?.sortOrder || "desc");
    const [deleteId, setDeleteId] = useState(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [deletingId, setDeletingId] = useState(null);

    const initialScrollYRef = useRef(blogsListCache?.scrollY || 0);
    const scrollRestoredRef = useRef(false);

    // 🟦 FIX: Endpoint changed from /blogs to /blog list (correct route)
    const fetchData = useCallback(async () => {
        setLoading(true);

        try {
            const response = await api.get(`/blogs`, {
                params: {
                    page: currentPage,
                    limit: itemsPerPage,
                    search: searchTerm,
                    sortField,
                    sortOrder,
                },
            });

            if (response.data.success) {
                const blogs = response.data.posts || [];
                setData(blogs);
                setTotalItems(response.data.total || blogs.length);
            } else {
                setData([]);
                setTotalItems(0);
            }
        } catch (err) {
            console.error("Error fetching blog list:", err);
            setData([]);
            setTotalItems(0);
        } finally {
            setLoading(false);
        }
    }, [currentPage, itemsPerPage, searchTerm, sortField, sortOrder]);

    useEffect(() => {
        fetchData();
    }, [currentPage, itemsPerPage, searchTerm, sortField, sortOrder, refreshTrigger, fetchData]);

    useEffect(() => {
        blogsListCache = {
            ...(blogsListCache || {}),
            currentPage,
            itemsPerPage,
            searchTerm,
            sortField,
            sortOrder,
        };
    }, [currentPage, itemsPerPage, searchTerm, sortField, sortOrder]);

    useEffect(() => {
        return () => {
            blogsListCache = {
                ...(blogsListCache || {}),
                scrollY: window.scrollY || 0,
            };
        };
    }, []);

    useEffect(() => {
        if (loading) return;
        if (scrollRestoredRef.current) return;
        scrollRestoredRef.current = true;
        const y = Number(initialScrollYRef.current || 0);
        if (y > 0) {
            requestAnimationFrame(() => window.scrollTo(0, y));
        }
    }, [loading]);

    // 🟦 FIX: Delete route should match backend (soft delete)
    const handleDelete = async () => {
        if (!deleteId) return;
        if (deletingId) return;

        setDeletingId(deleteId);

        try {
            await api.delete(`/blogs/${deleteId}`);

            setDeleteId(null);
            setRefreshTrigger((prev) => prev + 1);

            const remaining = Math.max(totalItems - 1, 0);
            if (currentPage > 1 && remaining > 0 && remaining % itemsPerPage === 0) {
                setCurrentPage((prev) => Math.max(1, prev - 1));
            }
        } catch (err) {
            console.error("Delete failed:", err);
            alert("Failed to move blog to trash.");
        } finally {
            setDeletingId(null);
        }
    };

    const handleSort = (field) => {
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("asc");
        }
        setCurrentPage(1);
    };

    return (
        <>
            <Helmet>
                <title>Admin | Blogs</title>
            </Helmet>

            <Sidebar isSidebarOpen={isSidebarOpen} />

            <div
                className={`content-overlay ${isSidebarOpen && window.innerWidth <= 992 ? "blurred" : ""
                    }`}
                onClick={() =>
                    isSidebarOpen &&
                    window.innerWidth <= 992 &&
                    toggleSidebar()
                }
            >
                <div
                    className="content-wrapper"
                    style={{
                        marginLeft: isSidebarOpen ? "250px" : "70px",
                        transition: "margin-left .3s",
                    }}
                >
                    <Header toggleSidebar={toggleSidebar} />

                    <section className="content">
                        <div className="breadcrumb-main-bx">
                            <div className="breadcrumb-bx">
                                <Link className="breadcrumb-link" to="/admin/dashboard">
                                    Dashboard
                                </Link>
                                <div className="breadcrumb-link breadcrumb-disabled">
                                    /
                                </div>
                                <div className="breadcrumb-link breadcrumb-active">
                                    Blogs
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header d-flex justify-content-between align-items-center">
                                            <div>Blogs</div>
                                            <Link
                                                to="/admin/bloglist/add"
                                                className="cbi-small common-btn-item cbi-fill text-decoration-none"
                                            >
                                                <span>Add Blog</span>
                                            </Link>
                                        </div>

                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered mt-2">
                                                    <thead>
                                                        <tr>
                                                            <th>No.</th>
                                                            <th
                                                                onClick={() => handleSort("title")}
                                                                className={`sorting_${sortField === "title"
                                                                    ? sortOrder
                                                                    : ""
                                                                    }`}
                                                            >
                                                                Title <SortIcon />
                                                            </th>

                                                            {/* 🟦 FIX: Show status using backend soft delete */}
                                                            <th>Status</th>

                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {loading ? (
                                                            Array.from({
                                                                length: itemsPerPage,
                                                            }).map((_, i) => (
                                                                <tr key={i}>
                                                                    <td colSpan={4}>
                                                                        <div className="skeletant-bx skeletant-design sh-47"></div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : data.length > 0 ? (
                                                            data.map((row, index) => (
                                                                <tr key={row._id}>
                                                                    <td>
                                                                        {itemsPerPage *
                                                                            (currentPage - 1) +
                                                                            index +
                                                                            1}
                                                                    </td>
                                                                    <td>{row.title}</td>

                                                                    {/* 🟩 Status logic fix */}
                                                                    <td>
                                                                        {row.isDeleted
                                                                            ? "Deleted"
                                                                            : "Active"}
                                                                    </td>

                                                                    <td>
                                                                        <Link
                                                                            to={`/admin/bloglist/edit/${row._id}`}
                                                                            className="common-action-btn"
                                                                        >
                                                                            <Icons.EditIcon />
                                                                        </Link>

                                                                        <Link
                                                                            to="#"
                                                                            className="common-action-btn"
                                                                            onClick={() =>
                                                                                setDeleteId(row._id)
                                                                            }
                                                                        >
                                                                            <Icons.DeleteIcon />
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={4} className="text-center">
                                                                    No blogs found.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination */}
                                            <div className="dataTables_info">
                                                Showing{" "}
                                                {totalItems === 0
                                                    ? 0
                                                    : itemsPerPage * (currentPage - 1) + 1}{" "}
                                                to{" "}
                                                {Math.min(
                                                    itemsPerPage * currentPage,
                                                    totalItems
                                                )}{" "}
                                                of {totalItems} entries
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Footer />
                </div>
            </div>

            {/* Delete Modal */}
            {deleteId && (
                <DeleteModal
                    isOpen={!!deleteId}
                    onClose={() => setDeleteId(null)}
                    onConfirm={handleDelete}
                    title="Move to Trash"
                    message="Are you sure you want to move this blog to the trash?"
                />
            )}
        </>
    );
}

export default BlogList;
